import {createRouter, createWebHistory} from 'vue-router'

const routes = [
    {
        path: '/',
        redirect: '/HomePage'
    },
    {
        //首页
        path: '/HomePage',
        name: 'HomePage',
        component: () => import('../views/HomePage/index.vue'),
        redirect: 'PathIndex',
        children: [
            {
                //首页内容组件
                path: '/PathIndex',
                name: 'PathIndex',
                component: () => import('../views/PageIndex/index')
            },
            {
                //核心内容内容组件
                path: '/CoreTechnology',
                name: 'CoreTechnology',
                component: () => import('../views/CoreTechnology/index.vue')
            },
            {
                //服务客户内容组件
                path: '/ServiceCustomer',
                name: 'ServiceCustomer',
                component: () => import('../views/ServiceCustomer/index')
            },
            {
                //通用产品内容组件
                path: '/GeneralProduct',
                name: 'GeneralProduct',
                component: () => import('../views/GeneralProduct/index.vue')
            },{
                //行业产品内容组件
                path: '/IndustryProducts',
                name: 'IndustryProducts',
                component: () => import('../views/IndustryProducts/index.vue')
            },{
                //关于我们内容组件
                path: '/AboutusIndex',
                name: 'AboutusIndex',
                component: () => import('../views/AboutusIndex/index.vue')
            },{
                //新闻中心内容组件
                path: '/NewsCenter',
                name: 'NewsCenter',
                component: () => import('../views/NewsCenter/index.vue')
            },{
                //新闻内容组件
                path: '/NewsContent',
                name: 'NewsContent',
                component: () => import('../views/NewsContent/index.vue')
            }
        ]
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
